var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxAcc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1213_21191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 0H3.33333C2.44928 0 1.60143 0.351189 0.976311 0.976311C0.351189 1.60143 0 2.44928 0 3.33333H0C0 3.86377 0.210714 4.37247 0.585786 4.74755C0.960859 5.12262 1.46957 5.33333 2 5.33333H14C14.507 5.33952 14.9971 5.15096 15.3692 4.80651C15.7413 4.46207 15.9671 3.98799 16 3.482C16.0196 3.03203 15.9479 2.58274 15.7893 2.16122C15.6306 1.73969 15.3882 1.35465 15.0768 1.0293C14.7653 0.703952 14.3912 0.445027 13.977 0.268129C13.5628 0.0912309 13.1171 2.25059e-05 12.6667 0V0Z",
    fill: "#7266BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6665 6.6665H1.33317C1.15636 6.6665 0.98679 6.73674 0.861766 6.86177C0.736742 6.98679 0.666504 7.15636 0.666504 7.33317V12.6665C0.667562 13.5502 1.01909 14.3975 1.64398 15.0224C2.26888 15.6473 3.11611 15.9988 3.99984 15.9998H11.9998C12.8836 15.9988 13.7308 15.6473 14.3557 15.0224C14.9806 14.3975 15.3321 13.5502 15.3332 12.6665V7.33317C15.3332 7.15636 15.2629 6.98679 15.1379 6.86177C15.0129 6.73674 14.8433 6.6665 14.6665 6.6665ZM9.99984 9.99984H5.99984C5.82303 9.99984 5.65346 9.9296 5.52843 9.80458C5.40341 9.67955 5.33317 9.50998 5.33317 9.33317C5.33317 9.15636 5.40341 8.98679 5.52843 8.86177C5.65346 8.73674 5.82303 8.6665 5.99984 8.6665H9.99984C10.1766 8.6665 10.3462 8.73674 10.4712 8.86177C10.5963 8.98679 10.6665 9.15636 10.6665 9.33317C10.6665 9.50998 10.5963 9.67955 10.4712 9.80458C10.3462 9.9296 10.1766 9.99984 9.99984 9.99984Z",
    fill: "#7266BA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1213_21191"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxAcc);
export default __webpack_public_path__ + "static/media/box-acc.2eeddf469bf85f9fe625de5ded206c6c.svg";
export { ForwardRef as ReactComponent };